export default __webpack_public_path__ + "static/media/2.928d51f7.jpg";